<mat-form-field class="menu-filter">
    <mat-label>Select Menu Mode</mat-label>
    <mat-select
        matInput
        [attr.data-testid]="'feature_scope_select'"
        [formControl]="featureScopeCtrl"
        [placeholder]="placeholderText"
    >
        <!-- Menu builder option group -->
        <mat-optgroup label="Menu Mode">
            <div class="remove-padding" *ngFor="let scope of featureScopes">
                <mat-option *ngIf="(isReadonly$ | async)"
                            [value]="scope.id"
                            [attr.data-testid]="scope.id + '_option'"
                >
                    {{ scope.name }}
                </mat-option>
                <mat-option *ngIf="!(isReadonly$ | async)"
                            [value]="scope.id"
                            [attr.data-testid]="scope.id + '_option'"
                >
                    {{ scope.name }}
                </mat-option>
            </div>
        </mat-optgroup>
    </mat-select>
</mat-form-field>
